import { render, staticRenderFns } from "./transferRecord.vue?vue&type=template&id=609b0df3&"
import script from "./transferRecord.vue?vue&type=script&lang=js&"
export * from "./transferRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports